export default __webpack_public_path__ + "static/media/tree17.a009554a.png";